import React, { useState, useEffect } from "react";
import moment from "moment";
import DinamicModal from '../../components/dinamicModal/dinamicModal';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import Request from "../../core/httpClient";
import cogoToast from 'cogo-toast';
import UnifiedDatePicker from '../../components/Calendario'; // Ajusta la ruta
import InputMask from 'react-input-mask';

const request = new Request();

function PropietarioEditarModal({ propietario, subLabel, escritura, closeModal, reload }) {
  // Estados
  const [idPersona, setIdPersona] = useState(propietario.id_persona || "");
  const [INombre, setINombre] = useState(propietario.nombre || "");
  const [IDireccion, setIDireccion] = useState(propietario.direccion || "");
  const [IMunicipio, setIMunicipio] = useState(propietario.municipio || "");
  const [IEstado, setIEstado] = useState(propietario.estado || "");
  const [ICp, setICp] = useState(propietario.cp || "");
  const [ITelefono, setITelefono] = useState(propietario.telefono || "");
  const [IPais, setIPais] = useState(propietario.pais || "");
  const [IGenero, setIGenero] = useState(propietario.genero || "");
  const [IId, setIId] = useState(propietario.tipo_identificacion || 0);
  const [INumId, setINumId] = useState(propietario.num_identificacion || "");
  const [IVigencia, setIVigencia] = useState(propietario.vigencia_identificacion || "");
  const [code, setCode] = useState(propietario.code || "");
  const [Iviv, setIviv] = useState(propietario.numero_registro || "");
  const [IIdViv, setIIdViv] = useState(propietario.id_vivienda || "");
  const [email, setEmail] = useState(propietario.email || "");
  const [citye, setCitye] = useState(propietario.ciudad || "");
  const [comentarios, setComentarios] = useState(propietario.comentarios || "");
  const [esResidente, setEsResidente] = useState(propietario.es_residente || false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [telefonoError, setTelefonoError] = useState(undefined);
  const [pFechaCompra, setPFechaCompra] = useState(propietario.fecha_compra || "");
  const [pFechaVenta, setPFechaVenta] = useState(propietario.fecha_venta || "");

  useEffect(() => {
    setIdPersona(propietario.id_persona || "");
    setINombre(propietario.nombre || "");
    setIDireccion(propietario.direccion || "");
    setIMunicipio(propietario.municipio || "");
    setIEstado(propietario.estado || "");
    setICp(propietario.cp || "");
    setITelefono(propietario.telefono || "");
    setIPais(propietario.pais || "");
    setIGenero(propietario.genero || "");
    setIId(propietario.tipo_identificacion || 0);
    setINumId(propietario.num_identificacion || "");
    setIVigencia(propietario.vigencia_identificacion || "");
    setCode(propietario.code || "");
    setIviv(propietario.numero_registro || "");
    setIIdViv(propietario.id_vivienda || "");
    setEmail(propietario.email || "");
    setCitye(propietario.ciudad || "");
    setComentarios(propietario.comentarios || "");
    setEsResidente(propietario.es_residente || false);
    setPFechaCompra(propietario.fecha_compra || "");
    setPFechaVenta(propietario.fecha_venta || "");
  }, [propietario]);

  const handleClose = () => {
    closeModal();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoadingSave(true);

    if (!isValidPhoneNumber(ITelefono)) {
      setTelefonoError("Número inválido");
      setLoadingSave(false);
      return;
    } else {
      setTelefonoError(undefined);
    }

    const resident = esResidente ? 1 : 0;

    const data = {
      idVivienda: IIdViv,
      Nombre: INombre,
      Direccion: IDireccion,
      Municipio: IMunicipio,
      Estado: IEstado,
      cp: ICp,
      Telefono: ITelefono,
      Pais: IPais,
      Genero: IGenero,
      TipoId: IId,
      NumId: INumId,
      Vigencia: IVigencia,
      FechaCompra: pFechaCompra,
      FechaVenta: pFechaVenta,
      Code: code,
      IdPersona: idPersona,
      email: email,
      idFraccionamiento: localStorage.getItem("frac") || 0,
      city: citye,
      comentarios: comentarios,
      id_usuario_upd: localStorage.getItem("user_id"),
      residente: resident,
    };

    const response = await request.post("/propietarios/update", data);

    if (response.updated && !response.empty) {
      reload();
      cogoToast.success("Datos del propietario actualizados.", {
        position: "bottom-right",
      });
    } else {
      cogoToast.error("No se pudieron actualizar datos del propietario.", {
        position: "bottom-right",
      });
    }

    setLoadingSave(false);
  };

  // Convertir strings a Date para UnifiedDatePicker (con validación)
  const fechaCompraObj = pFechaCompra && moment(pFechaCompra, 'YYYY-MM-DD', true).isValid()
    ? moment(pFechaCompra, 'YYYY-MM-DD', true).toDate()
    : null;
  const fechaVentaObj = pFechaVenta && moment(pFechaVenta, 'YYYY-MM-DD', true).isValid()
    ? moment(pFechaVenta, 'YYYY-MM-DD', true).toDate()
    : null;

  return (
    <DinamicModal
      idModal="editPropietario"
      sizeModalContainer="big"
      title="Editar propietario"
      success={handleSubmit}
      showBtnSuccess={escritura}
      btnTextSuccess="GUARDAR"
      showBtnCancel={true}
      btnTextCancel="CANCELAR"
      loadingSave={loadingSave}
      closeModal={handleClose}
    >
      {/* === FILA 1: SubLabel + Vivienda === */}
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-4 tw-gap-y-2 tw-mb-2">
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">{subLabel}:</label>
          <input
            type="text"
            value={propietario.subname || ""}
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm"
            disabled
          />
        </div>
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">Vivienda:</label>
          <input
            type="text"
            value={Iviv}
            onChange={(e) => setIviv(e.target.value)}
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm"
            disabled
            required
          />
        </div>
      </div>

      {/* === FILA 2: Teléfono + Nombre completo === */}
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-4 tw-gap-y-2 tw-mb-2">
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">
            Teléfono: <span className="tw-text-red-500">*</span>
          </label>
          <PhoneInput
            defaultCountry="MX"
            value={ITelefono}
            onChange={(value) => setITelefono(value)}
            error={telefonoError}
            disabled
            readOnly
            containerStyle={{ flex: 1 }}
            inputStyle={{
              width: '100%',
              padding: '0.25rem 0.5rem',
              fontSize: '0.875rem',
              background: '#f3f4f6',
              border: '1px solid #d1d5db',
              borderRadius: '0.25rem',
            }}
          />
        </div>
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">
            Nombre: <span className="tw-text-red-500">*</span>
          </label>
          <input
            type="text"
            value={INombre}
            onChange={(e) => setINombre(e.target.value)}
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm"
            disabled
            required
          />
        </div>
      </div>

      {/* === FILA 3: Género + Correo === */}
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-4 tw-gap-y-2 tw-mb-2">
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">Género:</label>
          <select
            value={IGenero}
            onChange={(e) => setIGenero(e.target.value)}
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm"
            required
          >
            <option value="0">Hombre</option>
            <option value="1">Mujer</option>
            <option value="2">No especificado</option>
          </select>
        </div>
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">Correo:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
          />
        </div>
      </div>

      {/* === FILA 4: Identificación + ID === */}
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-4 tw-gap-y-2 tw-mb-2">
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">Identificación:</label>
          <select
            value={IId}
            onChange={(e) => setIId(e.target.value)}
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm"
          >
            <option value="0">INE</option>
            <option value="1">Pasaporte/Visa</option>
            <option value="2">Curp</option>
            <option value="3">Cartilla Militar</option>
          </select>
        </div>
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">ID:</label>
          <input
            type="text"
            value={INumId}
            onChange={(e) => setINumId(e.target.value)}
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm"
          />
        </div>
      </div>

      {/* === FILA 5: Dirección + Municipio === */}
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-4 tw-gap-y-2 tw-mb-2">
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">Dirección:</label>
          <input
            type="text"
            value={IDireccion}
            onChange={(e) => setIDireccion(e.target.value)}
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm"
          />
        </div>
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">Municipio:</label>
          <input
            type="text"
            value={IMunicipio}
            onChange={(e) => setIMunicipio(e.target.value)}
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
          />
        </div>
      </div>

      {/* === FILA 6: Ciudad + CP === */}
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-4 tw-gap-y-2 tw-mb-2">
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">Ciudad:</label>
          <input
            type="text"
            value={citye}
            onChange={(e) => setCitye(e.target.value)}
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
          />
        </div>
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">C.P:</label>
          <input
            type="text"
            value={ICp}
            onChange={(e) => setICp(e.target.value)}
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
          />
        </div>
      </div>

      {/* === FILA 7: Estado + País === */}
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-4 tw-gap-y-2 tw-mb-2">
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">Estado:</label>
          <input
            type="text"
            value={IEstado}
            onChange={(e) => setIEstado(e.target.value)}
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
          />
        </div>
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">País:</label>
          <input
            type="text"
            value={IPais}
            onChange={(e) => setIPais(e.target.value)}
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
          />
        </div>
      </div>

      {/* === FILA 8: Fechas con UnifiedDatePicker === */}
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-4 tw-gap-y-2 tw-mb-2">
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">
            Fecha compra: <span className="tw-text-red-500">*</span>
          </label>
          <UnifiedDatePicker
            selected={fechaCompraObj}
            onChange={(date) => {
              const formatted = date ? moment(date).format('YYYY-MM-DD') : '';
              setPFechaCompra(formatted);
            }}
            includeTime={false}
            dateFormat="dd/MM/yyyy"
            placeholderText="DD/MM/YYYY"
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
            id="fcompra"
            customInput={
              <InputMask
                mask="99/99/9999"
                maskChar={null}
                className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
                placeholder="DD/MM/YYYY"
              />
            }
          />
        </div>
        <div className="tw-flex tw-items-center">
          <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0">Fecha venta:</label>
          <UnifiedDatePicker
            selected={fechaVentaObj}
            onChange={(date) => {
              const formatted = date ? moment(date).format('YYYY-MM-DD') : '';
              setPFechaVenta(formatted);
            }}
            includeTime={false}
            dateFormat="dd/MM/yyyy"
            placeholderText="DD/MM/YYYY"
            className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
            id="fventa"
            customInput={
              <InputMask
                mask="99/99/9999"
                maskChar={null}
                className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
                placeholder="DD/MM/YYYY"
              />
            }
          />
        </div>
      </div>

      {/* === FILA 9: Comentarios (ocupa toda la fila) === */}
      <div className="tw-flex tw-items-start tw-mb-2">
        <label className="tw-font-bold tw-text-sm tw-w-36 tw-text-left tw-flex-shrink-0 pt-1">Comentarios:</label>
        <textarea
          value={comentarios}
          onChange={(e) => setComentarios(e.target.value)}
          rows="2"
          maxLength="500"
          className="tw-flex-1 tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-rounded tw-bg-gray-100 tw-text-sm resize-y focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
        />
      </div>

      {/* === Estado residente + nota === */}
      <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-text-sm tw-mt-1">
        <div>
          {esResidente ? (
            <span className="tw-text-green-600 tw-font-bold tw-flex tw-items-center tw-gap-1">
              <b>Es residente</b> <i className="fas fa-check"></i>
            </span>
          ) : (
            <span className="tw-text-red-600 tw-font-bold"><b>No es residente</b></span>
          )}
        </div>
        <div className="tw-text-gray-600">
          <small><b className="tw-text-red-500"> * </b> Indica un campo obligatorio</small>
        </div>
      </div>
    </DinamicModal>
  );
}

export default PropietarioEditarModal;